import React from 'react';

function ErrorMessage({ message, onRetry }) {
  return (
    <div className="error-container">
      <div className="error-icon">
        <i className="fas fa-exclamation-circle"></i>
      </div>
      <p className="error-message">{message || 'An error occurred'}</p>
      {onRetry && (
        <button onClick={onRetry} className="btn btn-primary">
          <i className="fas fa-redo"></i> Retry
        </button>
      )}
    </div>
  );
}

export default ErrorMessage;